<div class="assets-sidebar">
  <button class="close-button" matTooltip="Close filters" i18n-matTooltip (click)="requestClose.emit($event)">
    <mat-icon class="material-icons-outlined">close</mat-icon>
    <span i18n class="sr-only" i18n>Close filters</span>
  </button>

  <div *ngIf="!['createProject', 'shareAssets', 'createStepper'].includes(configObject?.callFrom)">
    <div class="filter-box relative">
      <button mat-flat-button type="button" class="filter-button button-primary" (click)="viewAssetTags.emit()" tourAnchor="assets-filter-tags.anchor">
        <mat-icon class="material-icons-outlined">sell</mat-icon>
        <span class="filter-label-wrapper">
          <span class="filter-label font-bold" i18n>Tags</span>
        </span>
      </button>
    </div>
  </div>
  <sp-filter-forms
    #filterForms
    [formData]="filterAssetFormData"
    [filterType]="'asset'"
    [selectedFilterObject]="selectedFilterObject"
    [resetFilterForm]="formResetter"
    [roles]="['global.library']"
    (clickApplyFilter)="applyFilters.emit($event)"
    (dropDownChange)="updateFormData.emit($event)"
  >
  </sp-filter-forms>
</div>
